/* eslint-disable radix */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React from 'react';
import { Button, Form, FormGroup, Input, Label, Spinner } from 'reactstrap';
import { FaSearch } from 'react-icons/fa';
import { useDispatch } from 'react-redux';

import { Container } from './styles';

import Lista from './Lista';
import { addModuloPaginaID } from '~/store/modules/Paginas/actions';

function Card({
  modulos,
  handleGetPagesData,
  loading,
  selected,
  handleDelete,
  moduloNome,
}) {
  const dispatch = useDispatch();
  return (
    <Container>
      <Form style={{ width: '100%' }} onSubmit={handleGetPagesData}>
        <FormGroup>
          <Label>Selecione o módulo para visualizar as páginas</Label>
          <Input
            placeholder="Selecione..."
            type="select"
            onChange={(e) => {
              dispatch(addModuloPaginaID(parseInt(e.target.value)));
            }}
            defaultValue=""
            disabled={loading}
          >
            <option value="" disabled>
              Selecione...
            </option>
            {modulos.map((modulo, index) => (
              <option key={index} value={modulo.id}>
                {modulo.nome}
              </option>
            ))}
          </Input>
        </FormGroup>
        {loading ? (
          <Button color="primary" disabled>
            <Spinner size="sm" color="light" />
          </Button>
        ) : (
          <Button color="primary" onClick={handleGetPagesData}>
            <FaSearch /> Buscar
          </Button>
        )}
      </Form>
      {selected ? (
        <Lista
          moduloNome={moduloNome}
          handleDelete={handleDelete}
          loading={loading}
        />
      ) : (
        ''
      )}
    </Container>
  );
}

export default Card;
